<template>
	<div>
		<!-- Content wrapper -->
		<div
			ref="content"
			:style="contentStyle"
			class="position-relative transition-max-height"
		>
			<slot></slot>

			<!-- Fade overlay when collapsed -->
			<div v-if="isOverflowing && !expanded" class="fade-overlay d-flex justify-content-center align-items-end">
				<b-button variant="secondary" @click="toggle" class="mb-1 rounded-circle">
					&#9660;
				</b-button>
			</div>
		</div>

		<!-- Centered toggle button -->
		<div v-if="isOverflowing && expanded" class="text-center">
			<b-button variant="dark" @click="toggle" class="rounded-circle mt-2">
				&#9650;
			</b-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		maxHeight: {
			type: Number,
			default: 100, // px
		}
	},
	data() {
		return {
			expanded: false,
			isOverflowing: false,
			scrollHeight: 0
		}
	},
	computed: {
		contentStyle() {
			return this.expanded
				? { maxHeight: this.scrollHeight + 'px' } // fully expand
				: { maxHeight: this.maxHeight + 'px', overflow: 'hidden' }
		}
	},
	mounted() {
		this.checkOverflow()

		if('ResizeObserver' in window) {
			this.resizeObserver = new ResizeObserver(() => {
				this.checkOverflow()
			})
			this.resizeObserver.observe(this.$refs.content)
		} else {
			window.addEventListener('resize', this.checkOverflow)
		}
	},
	beforeDestroy() {
		if(this.resizeObserver) {
			this.resizeObserver.disconnect()
		} else {
			window.removeEventListener('resize', this.checkOverflow)
		}
	},
	methods: {
		toggle() {
			this.expanded = !this.expanded
		},
		checkOverflow() {
			if (this.$refs.content) {
				this.scrollHeight = this.$refs.content.scrollHeight
				this.isOverflowing = this.scrollHeight > this.maxHeight
			}
		}
	}
}
</script>

<style lang="scss">
@import '../plugins/variable.scss';

.transition-max-height {
	transition: max-height 0.3s ease;
	position: relative;

	/* Gradient fade at the bottom */
	.fade-overlay {
		pointer-events: none;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 3rem; /* fade area height */
		background: linear-gradient(to bottom, rgba($list-group-bg, 0), $list-group-bg);

		.btn {
			pointer-events: auto;
		}
	}
}

.list-group-striped {
	.list-group-item:nth-child(even) {
		.transition-max-height {
			.fade-overlay {
				background: linear-gradient(to bottom, rgba(lighten($list-group-bg-even, 10%), 0), $list-group-bg-even);
				.btn-secondary {
					background-color: $dark;
					border-color: $dark;
				}
			}
		}
	}
}
</style>
